import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _config;

import React from "react";
import ReactPaginate from 'react-paginate';
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
var config = (_config = {
  previousLabel: 'previous',
  nextLabel: 'next',
  breakLabel: '...',
  breakClassName: 'break-me',
  marginPagesDisplayed: 1,
  pageRangeDisplayed: 3,
  containerClassName: 'pagination',
  subContainerClassName: 'page-item',
  pageClassName: 'page-item',
  pageLinkClassName: 'page-link'
}, _defineProperty(_config, "breakClassName", 'page-item'), _defineProperty(_config, "breakLinkClassName", 'page-link'), _defineProperty(_config, "previousClassName", "page-item previous"), _defineProperty(_config, "previousLinkClassName", "page-link"), _defineProperty(_config, "nextClassName", "page-item next"), _defineProperty(_config, "nextLinkClassName", "page-link"), _defineProperty(_config, "nextLabel", /*#__PURE__*/React.createElement(FaChevronRight, null)), _defineProperty(_config, "previousLabel", /*#__PURE__*/React.createElement(FaChevronLeft, null)), _defineProperty(_config, "activeClassName", 'current'), _config);
export var PageCounter = function PageCounter(_ref) {
  var totalPages = _ref.totalPages,
      currentPage = _ref.currentPage,
      handleChange = _ref.handleChange;
  return /*#__PURE__*/React.createElement(ReactPaginate, _extends({}, config, {
    pageCount: totalPages,
    onPageChange: function onPageChange(e) {
      return handleChange(e.selected);
    },
    forcePage: currentPage
  }));
};